<template>
  <select-input
    id="forum-tag-select"
    :options="tagOptions"
    @change="onChange"
  ><span class="visually-hidden">Select forum tags</span>
  </select-input>
</template>

<script>
import SelectInput from '@/components/Inputs/SelectInput.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'ForumTagSelect',
  components: {
    SelectInput,
  },
  props: {
    forumTags: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['selectedTags']),
    selected() {
      return this.selectedTags[0] || '';
    },
    forumTagsToOptions() {
      return this.forumTags.map((tag) => ({
        name: tag.name,
        value: tag.id,
        selected: tag.id === this.selected,
      }));
    },
    tagOptions() {
      return [{
        name: 'Category',
        value: '',
      }].concat(this.forumTagsToOptions);
    },
  },
  methods: {
    onChange(value) {
      this.$store.dispatch('setSelectedTags', value ? [value] : []);
    },
  },
};
</script>

<docs>

A select menu for forum tags, used on mobile only where the tagpicker is not displayed

</docs>
